export default {"src":"/_next/static/media/search.d4a94abd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};